import { MessageCircle, Check, CheckCheck, Image as ImageIcon, Smile } from "lucide-react";

export default function ChatMockup() {
  return (
    <div className="relative w-full max-w-md mx-auto">
      <div className="absolute -inset-6 bg-[#25D366]/20 blur-3xl rounded-3xl" aria-hidden />
      <div className="relative bg-white rounded-[28px] border border-slate-200 shadow-2xl p-3">
        <div className="rounded-[20px] bg-[#0F172A] text-white p-4 flex items-center gap-3">
          <div className="w-9 h-9 rounded-full bg-[#25D366] grid place-items-center">
            <MessageCircle className="w-5 h-5" />
          </div>
          <div>
            <div className="text-sm font-semibold">GrabNChat Store</div>
            <div className="text-[11px] text-emerald-300 flex items-center gap-1"><span className="w-1.5 h-1.5 rounded-full bg-emerald-400 inline-block" /> online</div>
          </div>
        </div>

        <div className="bg-[url('data:image/svg+xml;utf8,<svg xmlns=%22http://www.w3.org/2000/svg%22 width=%22120%22 height=%22120%22><circle cx=%2210%22 cy=%2210%22 r=%221%22 fill=%22%23E2E8F0%22/></svg>')] bg-repeat px-4 py-5 space-y-2">
          <Bubble from="them">Hi! Interested in the new collection 👗</Bubble>
          <Bubble from="me">Hey Aisha! Here are this week’s top picks 💫</Bubble>
          <div className="flex gap-2 ml-auto justify-end">
            <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-pink-300 to-rose-400" />
            <div className="w-20 h-20 rounded-xl bg-gradient-to-br from-amber-300 to-orange-400" />
          </div>
          <Bubble from="them">I&apos;ll take the rose one. Cash on delivery? 🙏</Bubble>
          <Bubble from="me">Order confirmed ✅ tracking: GNC2391</Bubble>
        </div>

        <div className="px-3 py-3 flex items-center gap-2 border-t border-slate-100">
          <Smile className="w-5 h-5 text-slate-400" />
          <div className="flex-1 h-9 rounded-full bg-slate-100" />
          <ImageIcon className="w-5 h-5 text-slate-400" />
        </div>
      </div>

      <div className="hidden md:block absolute -right-10 -bottom-6 bg-white rounded-2xl border border-slate-200 shadow-xl p-3 w-56">
        <div className="text-xs text-slate-500">Today</div>
        <div className="text-2xl font-display font-bold text-slate-900">12,498</div>
        <div className="text-xs text-emerald-600 font-medium">+38% vs last week</div>
        <div className="mt-3 h-10 flex items-end gap-1">
          {[18, 24, 12, 30, 22, 36, 28, 42, 32, 48].map((h, i) => (
            <div key={i} className="flex-1 rounded-sm bg-[#25D366]/80" style={{ height: `${h * 1.2}%` }} />
          ))}
        </div>
      </div>

      <div className="hidden md:block absolute -left-10 top-6 bg-white rounded-2xl border border-slate-200 shadow-xl p-3 w-48">
        <div className="text-xs text-slate-500">Open rate</div>
        <div className="text-2xl font-display font-bold text-slate-900">98.2%</div>
        <div className="text-xs text-slate-500 mt-1 flex items-center gap-1"><CheckCheck className="w-3 h-3 text-emerald-500" /> Delivered</div>
      </div>
    </div>
  );
}

function Bubble({ from, children }) {
  const isMe = from === "me";
  return (
    <div className={`max-w-[78%] ${isMe ? "ml-auto bg-[#DCF8C6]" : "bg-white"} rounded-2xl px-3 py-2 text-sm text-slate-900 shadow-sm`}>
      {children}
      {isMe && <div className="text-[10px] text-slate-500 text-right mt-1 flex items-center gap-0.5 justify-end">10:24 <CheckCheck className="w-3 h-3 text-sky-500" /></div>}
    </div>
  );
}
